import * as React from 'react';
import { CommandItem } from './Command';
import { IconSquare, IconSquareCheck } from '@tabler/icons-react';
import type { SelectableCommandItemProps } from './types';

export const SelectableCommandItem = React.forwardRef<
  HTMLDivElement,
  SelectableCommandItemProps
>(({ selected, children, className, ...props }, ref) => {
  return (
    <CommandItem ref={ref} {...props} className={className}>
      {selected ? <IconSquareCheck /> : <IconSquare />}
      {children}
    </CommandItem>
  );
});

SelectableCommandItem.displayName = 'SelectableCommandItem';
